// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3O2x9","head":"Table_head__d3Gtr","col":"Table_col__360y4"};